module.exports = __webpack_public_path__ + "img/coin-005.9cdea84a.svg";